var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallMountain(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 89,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-22 0l-48 48v40.5h177.5l-53-53L34 56-22 0z",
    fill: "#0E0E0E",
    fillOpacity: 0.64
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallMountain);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg width='108' height='89' viewBox='0 0 108 89' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M-22 0L-70 48V88.5H107.5L54.5 35.5L34 56L-22 0Z' fill='%230E0E0E' fill-opacity='0.64'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };